export const secondsToMs = (sec: number) => sec * 1000;
